var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.5C4.25 1.5 4.5 1.75 4.5 2.25V21.75C4.5 22.25 4.25 22.5 3.75 22.5C3.25 22.5 3 22.25 3 21.75V2.25C3 1.75 3.25 1.5 3.75 1.5ZM13.5 9.8115L16.5 9.54V3.96L13.5 3.69V9.81V9.8115ZM12 9.948V3.552L7.5 3.1425V3.75H6V1.5L20.454 2.814C21.0132 2.86491 21.5331 3.12303 21.9116 3.53768C22.2902 3.95233 22.5001 4.49353 22.5 5.055V8.445C22.5001 9.00647 22.2902 9.54767 21.9116 9.96232C21.5331 10.377 21.0132 10.6351 20.454 10.686L6 12V5.25H7.5V10.3575L12 9.948ZM18 9.4035L20.3175 9.1935C20.5042 9.17663 20.6779 9.09042 20.8042 8.95188C20.9305 8.81333 21.0004 8.63249 21 8.445V5.055C21 4.86777 20.93 4.6873 20.8037 4.54907C20.6774 4.41084 20.504 4.32485 20.3175 4.308L18 4.098V9.4035Z",
    fill: "#FFC888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/wind_speed.14a12b4df2f41274bf8eafdd12f90e7d.svg";
export { ForwardRef as ReactComponent };